import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { CarrierService } from 'modules/inventory/provider/carriers/services';
import { CARRIER_LIST_KEY } from 'modules/inventory/provider/carriers/constants';

export const useDeleteCarrier = (carrierId: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('carriers');

  return useMutation(
    () => CarrierService.delete(carrierId),
    {
      onSuccess: () => {
        toast.success(t('successDeleted'));
        queryClient.invalidateQueries({ queryKey: [CARRIER_LIST_KEY] });
        onClose();
      },
      onError: () => {
        toast.error(t('common:errors.generalErrorMessage'));
      },
    },
  );
};
